/* ../lib/components/parts/Header/Header.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space
} from "svelte/internal";

import { createEventDispatcher } from "svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-1c4qacu-style";
	style.textContent = "header.svelte-1c4qacu{width:100%;background:#333;display:grid;grid-template-columns:auto auto;justify-content:space-between;align-items:center}h1.svelte-1c4qacu{color:white;font-size:20px}div.svelte-1c4qacu{width:24px;height:24px;margin:6px;border-radius:12px;background-color:white;cursor:pointer;display:grid;align-items:center;justify-content:center}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let header;
	let h1;
	let t1;
	let div;
	let dispose;

	return {
		c() {
			header = element("header");
			h1 = element("h1");
			h1.textContent = "AM: MockTimes 🔧";
			t1 = space();
			div = element("div");
			div.textContent = "?";
			attr(h1, "class", "svelte-1c4qacu");
			attr(div, "class", "svelte-1c4qacu");
			attr(header, "class", "svelte-1c4qacu");
		},
		m(target, anchor) {
			insert(target, header, anchor);
			append(header, h1);
			append(header, t1);
			append(header, div);
			dispose = listen(div, "click", /*onHelpClick*/ ctx[0]);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(header);
			dispose();
		}
	};
}

function instance($$self) {
	const dispatch = createEventDispatcher();

	function onHelpClick() {
		dispatch("helpclick");
	}

	return [onHelpClick];
}

class Header extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1c4qacu-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Header;